import InlineSVG from '../../icons';
import PropTypes from 'prop-types';
import React from 'react';
import VideoOverlay from '../overlay/VideoOverlay';
import useIsMobile from '../homeV2/hooks/isMobile';

const VideoText = ({data, mobile}) => {
    const [showOverlay, setOverlay] = React.useState(false);
    const toggleOverlay = React.useCallback(() => {
        setOverlay(!showOverlay);
    }, [setOverlay, showOverlay]);
    const isMobile = useIsMobile(mobile);
    if (!data) return null;
    const {border, titleOne, titleTwo, titleThree, video, description, showSlant} = data;
    const showVideo = video && video.type !== 'none' && isMobile;
    if (!showVideo) {
        return null;
    }
    return (
        <section className="videotext-block">
            <div className="container-fluid section">
                <div className="row">
                    {showVideo ? (<div className="col-xs-12 col-sm-6 col-md-5 col-md-offset-1">
                        <div className="content">
                            <div role="presentation" className="video-container" onClick={toggleOverlay}>
                                <div className="video-border" style={{backgroundImage: `url(${border})`}} />
                                <img src={video.desktopImage} alt="video-screen" />
                                <div className="hex-button-container">
                                    <InlineSVG
                                        name="hexButton"
                                        className="hexButton"
                                        viewBox="0 0 26.33 30.77"
                                    />
                                    <span className="icon-play-triangle" />
                                </div>
                            </div>
                        </div>
                    </div>) : null}
                    <div className={showVideo ? "col-xs-12 col-sm-6 col-md-5 col-md-offset-1" : "col-12 align-items-center"}>
                        <div className="text-container">
                            <h2>
                                {titleOne}{titleOne && <br/>}
                                {titleTwo}{titleTwo && <br/>}
                                {titleThree}{titleThree && <br/>}
                            </h2>
                            {description && <p>{description}</p>}
                        </div>
                    </div>
                </div>
            </div>
            {showSlant && <InlineSVG name="slant" className="diagonal-clip" direction="obtuse-left" />}
            {showVideo ? (
                <VideoOverlay show={showOverlay} video={video} close={toggleOverlay} />
            ) : null}
        </section>
    );
};
VideoText.propTypes = {
    data: PropTypes.object,
    mobile: PropTypes.bool
}

export default VideoText;
